module.exports = __webpack_public_path__ + "static/media/notebook01.960c98ef.jpg";